var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334.806l.879 1.648 1.649.88-1.649.879-.88 1.648-.879-1.648-1.648-.88 1.649-.879.879-1.648zm-6 2.083l1.778 3.333L10.445 8 7.112 9.778 5.334 13.11 3.556 9.778.223 8l3.333-1.778L5.334 2.89zm7.777 8l-1.11-2.083-1.112 2.083L8.806 12l2.083 1.111 1.112 2.083 1.11-2.083L15.195 12l-2.084-1.111z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/stars-three.svg";
export { SvgStarsThree as ReactComponent };